module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/sorority-testimonial-28ec499cd1c732a789af41636a2e20fd.jpg";